import { SdkContext } from '../internal'
import type { DashboardSummary, ModerationKind, MonetizationMetrics, MonetizationPeriod } from '@/types/dashboard'

/** F-84: the team's day at a glance. Path written by hand (F-03). */
export class DashboardResource {
  constructor(private ctx: SdkContext) {}

  async summary(): Promise<DashboardSummary> {
    return this.ctx.call({ httpMethod: 'GET', path: '/dashboard/summary' })
  }

  /** API-188: revenue from the ledger (gross, refunds, chargebacks, net) in one currency; without `currency`, the API picks. */
  async monetization(params: { period?: MonetizationPeriod; currency?: string } = {}): Promise<MonetizationMetrics> {
    const query = Object.fromEntries(Object.entries(params).filter(([, v]) => v))
    return this.ctx.call({ httpMethod: 'GET', path: '/dashboard/monetization' }, { query })
  }

  /** Approves or rejects a queue item; rejecting takes a reason (classifieds may go without). */
  async moderate(kind: ModerationKind, id: string, status: 'APPROVED' | 'REJECTED', rejectionReason?: string): Promise<void> {
    return this.ctx.call(
      { httpMethod: 'PUT', path: '/moderation/{kind}/{id}', hasBody: true },
      { kind, id, body: { status, ...(rejectionReason ? { rejectionReason } : {}) } }
    )
  }
}
